module.exports = __webpack_public_path__ + "img/icon_webpage_outlined.2b7dc00a.svg";